export function formatFileName(filename: string, maxLength = 22) {
    const extIndex = filename.lastIndexOf('.');
    if (extIndex === -1 || filename.length <= maxLength) return filename;
    const name = filename.slice(0, extIndex);
    const ext = filename.slice(extIndex);
    const partLength = Math.floor((maxLength - 3) / 2);
    return name.slice(0, partLength) + '...' + name.slice(-partLength) + ext;
}
